import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const AmexGreyRegular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox='0 0 256 256'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#000000'
      d='M0 0v256h256v-40.448h-35.328l-13.056-15.273-13.568 15.273H93.696v-81.321H60.585l41.39-93.696h40.274l9.728 21.248V40.535h50.007l8.361 22.272 8.192-22.272H256V0H0Zm227.072 53.76-13.143 34.647-3.497 9.39-3.584-9.39-13.225-34.647h-28.928v68.27h17.408V77.573l-.087-8.965 3.415 8.965 16.64 44.457h16.553l16.727-44.457 3.241-8.878v53.335H256V53.76h-28.928Zm-115.712 0-30.208 68.27h19.794l5.294-13.143h33.111l5.289 13.143h20.055l-30.039-68.27H111.36Zm8.018 23.127 3.415-8.53 3.415 8.53 7.081 17.234h-20.992l7.08-17.234Zm109.061 57.431-20.567 22.098-20.48-22.098h-79.703v68.009h57.006v-14.76h-39.598v-11.864h38.83v-14.674h-38.83v-11.95h39.598v-14.76l31.826 34.129-31.826 33.879h22.016l20.736-22.185 20.649 22.185h22.61l-31.913-34.135 31.913-33.874h-22.267Zm8.274 33.792L256 187.735v-38.999l-19.287 19.374Z'
    />
  </svg>
)

export { AmexGreyRegular }
